"use client";

import { useEffect, useState } from "react";

export function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
        scrolled
          ? "bg-deep/80 backdrop-blur-xl border-b border-rule"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
        {/* Logo */}
        <a href="/" className="app-logo flex items-center group">
          <span className="font-['Days_One'] text-xl font-bold text-ink tracking-tight">
            md
          </span>
          <span className="font-['Libre_Baskerville'] text-xl font-normal text-ink tracking-tight">
            sync
          </span>
        </a>

        {/* Nav links — hidden on mobile */}
        <div className="hidden md:flex items-center gap-8 text-sm text-ink-secondary">
          <a
            href="/#features"
            className="hover:text-ink transition-colors duration-200"
          >
            Features
          </a>
          <a
            href="/#how-it-works"
            className="hover:text-ink transition-colors duration-200"
          >
            How It Works
          </a>
          <a
            href="/#why-git"
            className="hover:text-ink transition-colors duration-200"
          >
            Why Git
          </a>
        </div>

        {/* CTA */}
        <a
          href="/app/login"
          className="rounded-full bg-accent/10 border border-accent/20 px-5 py-2 text-sm font-medium text-accent hover:bg-accent/15 hover:border-accent/30 transition-all duration-200"
        >
          Get Started
        </a>
      </div>
    </nav>
  );
}
